import React from 'react';
import { HeaderContainer, FooterContainer, BottomNoteContainer, EmptyHeadContainer, CovidsationsBodyContainer } from '../containers';

export default function Covidsations() {
    return (
            <div>
                <HeaderContainer  />
                <EmptyHeadContainer />
                <CovidsationsBodyContainer />
                <BottomNoteContainer />
                <FooterContainer />
            </div>

    )
}